<template>
    <!-- BECOME A PARTNER MODAL -->
<div class="modal fade partnerModal" id="becomePartnerModal" tabindex="-1" aria-labelledby="sbecomePartnerModalLabel" aria-hidden="true" ref="becomePartnerModal">
	<div class="modal-dialog modal-lg modal-dialog-scrollable opacity-animate3">
		<div class="modal-content">
			<div class="modal-header modalHeader">
				<button type="button" class="custom-close" data-bs-dismiss="modal" v-on:click="modalClose()" aria-label="Close"><i class="ph-x-bold"></i></button>
			</div>
			<div class="modal-body">
				<div class="container-fluid">
					<div class="row">
						<div class="col-sm-12">
							<!-- start schedulePopUp -->
							<div class="plan-future-container" v-if="!isPartner">
								<h5 class="hf_heading05">Grow your business with us, Become a Partner</h5>
								<div class="container-fluid p-0">
									<form action="validatePartnerData" method="post" id="validatePartnerData">
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">Name <span class="hf_primary">*</span></label>
													<input type="text" class="form-control hf_customInput" v-model="fullname" maxlength="100" placeholder="Enter your name">
													<p class="errorMessage" v-if="errors['fullname'] && errors['fullname'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["fullname"] }}
													</p> 
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="email">Email <span class="hf_primary">*</span></label>
													<input type="email" class="form-control hf_customInput" v-model="email_address" maxlength="100" placeholder="Enter your email">
													<p class="errorMessage" v-if="errors['email_address'] && errors['email_address'] !== ''">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ errors["email_address"] }}
													</p>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container abc">
													<label for="number">Mobile <span class="hf_primary">*</span></label>
													<div class="country-code-container">
														<span class="plus-code">+</span>
														<input type="number" class="form-control hf_customInput conCode" v-model="country_code" :maxlength = "maxCountryCodeLength" >
														<input type="number" class="form-control hf_customInput telNo" v-model="mobile_number" @keypress="isMobileNumber($event)" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" :maxLength = "maxMobileLength" placeholder="Enter your mobile number">
													</div>
													<p class="errorMessage" v-if="errors['mobile_number'] && errors['mobile_number'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["mobile_number"] }}
													</p>
												</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container abc">
													<label for="number">Location <span class="hf_primary">*</span></label>
													<input type="text" class="form-control hf_customInput" v-model="location" placeholder="Enter your Location">
	                        						<p class="errorMessage" v-if="errors['location'] && errors['location'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["location"] }}
													</p>
	                      						</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">Age <span class="hf_primary">*</span></label>
													<input type="number" class="form-control hf_customInput" v-model="age" min="0" maxlength="2" @input="ageLimit()" placeholder="Enter your age">
	                        						<p class="errorMessage" v-if="errors['age'] && errors['age'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["age"] }}
													</p>
	                      						</div>
											</div>
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="email">ARN</label>
													<input type="text" class="form-control hf_customInput" v-model="arn" placeholder="Enter your ARN number" maxlength="20">
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-6">
												<div class="form-group hf_input-container">
													<label for="name">AUM <span class="hf_primary">*</span></label>
													<input type="number" class="form-control hf_customInput" v-model="aum" oninput="javascript: if (this.value.length >this.maxLength) this.value = this.value.slice(0, this.maxLength);" placeholder="Enter your AUM in crores" maxlength="5">
													<p class="errorMessage" v-if="errors['aum'] && errors['aum'] !== ''">
														<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
														{{ errors["aum"] }}
													</p>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12">
												<div class="form-group hf_input-container">
													<p class="hf_bodytext02">Do you have a plan to maximize the value of your business <span class="hf_primary">*</span></p>
													<div class="form-check form-check-inline customRadio">
													  <input class="form-check-input" type="radio" name="partnerMaxbusiness" id="inlineRadio1" value="1" v-model="partnerMaxbusiness">
													  <label class="form-check-label" for="inlineRadio1">Yes</label>
													</div>
													<div class="form-check form-check-inline customRadio">
													  <input class="form-check-input" type="radio" name="partnerMaxbusiness" id="inlineRadio2" value="0" v-model="partnerMaxbusiness">
													  <label class="form-check-label" for="inlineRadio2">No</label>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12">
												<div class="form-group hf_input-container">
													<p class="hf_bodytext02">Do you have a business succession plan <span class="hf_primary">*</span></p>
													<div class="form-check form-check-inline customRadio">
													  <input class="form-check-input" type="radio" name="partnerPlanbusiness" id="inlineRadio3" value="1" v-model="partnerPlanbusiness">
													  <label class="form-check-label" for="inlineRadio3">Yes</label>
													</div>
													<div class="form-check form-check-inline customRadio">
													  <input class="form-check-input" type="radio" name="partnerPlanbusiness" id="inlineRadio4" value="0" v-model="partnerPlanbusiness">
													  <label class="form-check-label" for="inlineRadio4">No</label>
													</div>
												</div>
											</div>
										</div>
										<div class="row">
											<div class="col-sm-12">
												<div class="form-group modalCaptcha-div">
													<VueRecaptcha 
											      sitekey="6Ldr460jAAAAAO6wyw1mVTSg_2T2Zp9WTkO9SL_9" 
											      ref="recaptchaModal"
											      size="invisible"
											      :load-recaptcha-script="true" 
											      @verify="recaptchaVerifiedModal" 
											      @expired="resetCaptchaModal">
											    </VueRecaptcha>
											  </div>
											</div>
										</div>
										<!-- button container -->
										<div class="row">
											<div class="col-sm-12">
												<div class="error-div">
												<p v-show="showPartnerError" class="errorMessage inflation-text hf_bodytext02">
													<span class="errorCircle"><span class="errorSymbol">&#33;</span></span>
													{{ showPartnerErrorText }}
												</p>
												</div>
												<div class="form-group hf_input-container">
													<div class="button-container">
														<button :disabled="isFormSubmitting" href="javascript:void(0)" type="button" class="btn-primaryNoIcon lg-primarynoIcon btnScheduleSession" v-on:click="executeCaptcha()">Become a partner</button>
													</div>
												</div>
											</div>
										</div>
									</form>
								</div>
							</div>
							<!-- end schedulePopUp -->
							<!-- start thank you note container -->
							<div class="thankYou-container" v-if="isPartner">
								<div class="thankYou-body">
									<div class="hoverEffects">
										<lottie-player src="/img/thanks-lottie.json" mode="normal" background="transparent" speed="1"  style="width: 80px; height: 80px;" autoplay loop></lottie-player>
									</div>
									<h3 class="hf_heading04">Thank you!</h3>
									<p class="hf_bodytext01">We will get back to you soon.</p>
								</div>
								<div class="button-container">
									<a href="javascript:void(0)" type="button" class="btn-primaryNoIcon md-primarynoIcon" v-on:click="modalClose()" data-bs-dismiss="modal" aria-label="Close">Got it</a>
								</div>
							</div>
							<!-- end start thank you note container -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
<!-- END BECOME A PARTNER MODAL -->
  </template>
  <script>
  import { VueRecaptcha } from 'vue-recaptcha';
  import { watch } from '@vue/runtime-core';
  export default {
  	components: {
	    VueRecaptcha
	  },
    data() {
      return {
        fullname: "",
        email_address: "",
        country_code: "91",
        mobile_number: "",
        errors: [],
        age:"",
        location:"",
        arn:"",
        aum:"",
        partnerMaxbusiness:"1",
        partnerPlanbusiness:"1",
        isFormSubmitting: false,
		isPartner: false,
        maxCountryCodeLength: 3,
        maxMobileLength: 10,
        recaptchaToken:'',
		showPartnerErrorText:'',
		showPartnerError: false,
      };
    },
    watch: {
      fullname(userName) {
        this.fullname = userName;
        this.errors["fullname"] = '';
        if( !this.validateCharacters(this.fullname) ) // Check is valid entered name
          this.errors["fullname"] = "Please enter valid Name.";
      },
      email_address(emailAddress) {
        this.email_address = emailAddress;
        let isValidEmail = this.validateEmail(emailAddress);
        this.errors["email_address"] = '';
        if (!isValidEmail) // Check is valid entered email
          this.errors["email_address"] = "Please enter valid Email Address.";
      },
      country_code(countryCode) {
        this.country_code = $.trim(countryCode);
        if (countryCode.toString().length > this.maxCountryCodeLength) {
          this.country_code = $.trim(countryCode.toString().slice(0, this.maxCountryCodeLength));
        }
        if (this.country_code.toString().length > 0 && this.country_code.toString().length <= this.maxCountryCodeLength ){
          this.errors["mobile_number"] = '';
          if( this.country_code == 91 ) {
              this.maxMobileLength = 10;
              if( this.mobile_number.toString().length > 0 ) {
                if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
                  this.errors["mobile_number"] = "Please enter valid Mobile Number.";
              }
          }
          else{
            this.maxMobileLength = 13;
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            if( this.mobile_number.toString().length > 0 ) {
              if( !this.validateInternationalMobileNumber(this.mobile_number) )
                this.errors["mobile_number"] = "Please enter valid Mobile Number.";
            }
          }
        }
        else
          this.errors["mobile_number"] = "Please enter valid Country Code";
      },
      mobile_number(mobileNumber){
        this.mobile_number = $.trim(mobileNumber);
        if( mobileNumber.toString().length > this.maxMobileLength ){
          this.mobile_number = $.trim(mobileNumber.toString().slice(0, this.maxMobileLength));
        }
        if( this.mobile_number.toString().length > 0 && this.country_code.toString().length > 0 ) {
          if( this.country_code == 91 ) {
            this.errors["mobile_number"] = '';
            if( !this.validateMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
          else {
            // console.log(" international "+this.validateInternationalMobileNumber(this.mobile_number));
            this.errors['mobile_number'] = '';
            if( !this.validateInternationalMobileNumber(this.mobile_number) ) // Check is valid entered mobile number
              this.errors["mobile_number"] = "Please enter valid Mobile Number.";
          }
        }
      },
      location(partner_location){
        this.location = partner_location;
        this.errors["location"] = '';
        if( !this.validateCharacters(this.location) ) // Check is valid entered name
          this.errors["location"] = "Please enter valid location.";
      },
      age(partner_age) {
        this.age = partner_age;
        this.errors["age"] = '';
        if( this.age == '' ) 
          this.errors["age"] = "Please enter valid age.";
      },
      aum(partner_aum) {
        this.aum = partner_aum;
        this.errors["aum"] = '';
        if( this.aum == '' ) 
          this.errors["aum"] = "Please enter AUM.";
      },
    },
    methods: {
    	resetCaptchaModal() {
	      this.$refs.recaptchaModal.reset();
	      this.recaptchaToken = "";
	    },
	    recaptchaVerifiedModal(token) {
	      if (token ){
			this.recaptchaToken = token;
			this.validatePartnerDataForm();
		  } 
	    },
      ageLimit: function(){
        var element = event.target;
        var maxlength = element.getAttribute('maxlength');
        if(this.age.toString().length > maxlength){
          let number = this.age;
          this.age = number.toString().substring(0, number.toString().length - 1);
        }
      },
	  async modalClose(){
		this.isPartner = false;
	  },
      async isMobileNumber(evt){
        evt = (evt) ? evt : window.event;
        var charCode = (evt.which) ? evt.which : evt.keyCode;
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault();;
        } else {
          return true;
        }
      },
	  executeCaptcha(){
		//execute captcha call here
        //=========================================
        this.$refs.recaptchaModal.execute();
	  },
      async validatePartnerDataForm(){
        var fullName = $.trim(this.fullname);
        var emailAddress = $.trim(this.email_address);
        var countryCode = $.trim(this.country_code);
        var mobileNumber = $.trim(this.mobile_number);
        var location = $.trim(this.location);
        var age = $.trim(this.age);
        var aum = $.trim(this.aum);
        var arn = $.trim(this.arn);
        var partnerMaxbusiness = $.trim(this.partnerMaxbusiness);
        var partnerPlanbusiness = $.trim(this.partnerPlanbusiness);
        // // LET'S VALIDATE FINAL FORM
        if(this.validateCharacters(fullName) && this.validateEmail(emailAddress) && countryCode.toString().length > 0 && ((countryCode == '91' && this.validateMobileNumber(mobileNumber)) || (countryCode !== '91' && this.validateInternationalMobileNumber(mobileNumber))) && this.validateCharacters(fullName) && this.validateCharacters(location) && aum > 0 && age != ''){
    		this.isFormSubmitting = true;
        
			// API data
			let userdata = {
				recaptcha_token: this.recaptchaToken,
				fullname: fullName,
				email: emailAddress,
				country_code: countryCode,
				mobile_number: mobileNumber,
				location:location,
				age:age,
				aum:aum,
				arn:arn,
				partnerMaxbusiness:partnerMaxbusiness,
				partnerPlanbusiness:partnerPlanbusiness,
			}
			console.log(userdata);
			axios.post('/sendNewPartnerNotification', userdata).then((apiResponse) => {
				this.isFormSubmitting = false;
                var responseData = apiResponse.data;
				console.log(responseData);
				if( responseData.status == 1 ){
					this.isPartner = true;
					this.showPartnerErrorText = '';
					this.showPartnerError = false;
					this.$refs.recaptchaModal.reset();
				}else{
					this.isPartner = false;
					this.showPartnerError = true;
					this.showPartnerErrorText = responseData.res;
					this.$refs.recaptchaModal.reset();
				}
			}).catch(response => {
				console.log(response.data);
				this.$refs.recaptchaModal.reset();
				this.isFormSubmitting = false;
			});
        }
        else {
			this.isFormSubmitting = false;
			this.$refs.recaptchaModal.reset();
          if (!this.validateCharacters(fullName))
            this.errors["fullname"] = "Please enter valid Name.";
          
          if( !this.validateCharacters(location) ) 
            this.errors["location"] = "Please enter valid location.";

          if (!this.validateEmail(emailAddress))
            this.errors["email_address"] = "Please enter valid Email Address.";

          if(age == '')
            this.errors["age"] = "Please enter valid age.";

          if(aum == '')
            this.errors["aum"] = "Please enter AUM.";
          
          if( (countryCode == '91' && !this.validateMobileNumber(mobileNumber)) ||
            (countryCode !== '91' && !this.validateInternationalMobileNumber(mobileNumber)) )
            this.errors["mobile_number"] = "Please enter valid Mobile Number.";
        }  // endif form validation
      },
      onModalHidden(){
		this.isPartner = false;
        this.fullname = "";
        this.email_address = "";
        this.mobile_number = "";
        this.country_code = "91";
        this.location = "";
        this.age = "";
        this.aum = "";
        this.arn = "";
		this.showPartnerErrorText = "";
		this.errors=[];
      },
      onModalShown(){
		this.isPartner = false;
        this.errors=[];
		this.showPartnerErrorText = "";
      },
    },
    mounted() {
      $(this.$refs.becomePartnerModal).on("hidden.bs.modal", this.onModalHidden);
      $(this.$refs.becomePartnerModal).on("shown.bs.modal", this.onModalShown);
    }
  };
  </script>
  
  
